import Campaign from 'mini-campaign/lib/store/Campaign';
import CampaignLightningRemoteSource from 'mini-campaign/lib/store/CampaignLightningRemoteSource';
import Journey from 'mini-campaign/lib/store/Journey';
import { CampaignId } from 'mini-campaign-bootstrap/lib/schema/CampaignId';
import { CampaignModal, CampaignModalConfig } from 'mini-campaign/lib/campaign-types/CampaignModal';
import { onLightningPresent } from 'mini-campaign-bootstrap/lib/utils/isLightningIdPresent';
import { waitBeforeStart } from '../utils/waitBeforeStart';
import {
    CampaignTooltip,
    CampaignTooltipConfig,
} from 'mini-campaign/lib/campaign-types/CampaignTooltip';
import {
    CampaignEmbeddedMessage,
    CampaignEmbeddedMessageConfig,
} from 'mini-campaign/lib/campaign-types/CampaignEmbeddedMessage';

const DELAY_AFTER_RENDER_IN_MILLISECONDS = 2000;

let mailCalendarNudgeCampaign: Campaign<CampaignTooltipConfig> = null;
let mailCalendarNudgeJourney: Journey = null;
let mailWarmWelcomeCampaign: Campaign<CampaignModalConfig> = null;
let mailWarmWelcomeJourney: Journey = null;
let mailFocusedOthersCampaign: Campaign<CampaignEmbeddedMessageConfig> = null;
let mailMultiSelectCampaign: Campaign<CampaignEmbeddedMessageConfig> = null;
let mailEdgeUpsellCampaign: Campaign<CampaignEmbeddedMessageConfig> = null;

let isMailCampaignObjectsInitialized = false;

function initializeMailCampaignObjects() {
    /**
     * Mini Mail campaign object
     */
    mailCalendarNudgeCampaign = new Campaign<CampaignTooltipConfig>({
        remoteCampaignId: CampaignId.MiniCalendarModuleSwitch,
        campaignSource: CampaignLightningRemoteSource.getInstance(
            CampaignId.MiniCalendarModuleSwitch,
            { dismiss: 'Primary', unmount: 'Primary' }
        ),
        rule: async () => await onLightningPresent(CampaignId.MiniCalendarModuleSwitch),
        campaignType: new CampaignTooltip(),
    });

    mailCalendarNudgeJourney = new Journey(async () => {
        await waitBeforeStart(DELAY_AFTER_RENDER_IN_MILLISECONDS /* Delay of 2 seconds */);
        mailCalendarNudgeCampaign.start();
    });

    /**
     * Mail warm campaign object
     */
    mailWarmWelcomeCampaign = new Campaign<CampaignModalConfig>({
        remoteCampaignId: CampaignId.MiniWarmWelcome,
        campaignSource: CampaignLightningRemoteSource.getInstance(CampaignId.MiniWarmWelcome, {
            dismiss: 'Primary',
            unmount: 'Primary',
        }),
        rule: async () => await onLightningPresent(CampaignId.MiniWarmWelcome),
        campaignType: new CampaignModal(),
    });

    mailWarmWelcomeJourney = new Journey(async () => {
        await waitBeforeStart();
        mailWarmWelcomeCampaign.start();
    });

    /** Mail focused others campaign object */
    mailFocusedOthersCampaign = new Campaign<CampaignEmbeddedMessageConfig>({
        remoteCampaignId: CampaignId.MiniMailFocusOthers,
        campaignSource: CampaignLightningRemoteSource.getInstance(CampaignId.MiniMailFocusOthers, {
            dismiss: 'Primary',
        }),
        rule: async () => await onLightningPresent(CampaignId.MiniMailFocusOthers),
        campaignType: new CampaignEmbeddedMessage(),
    });

    /** Mail multi select campaign */
    mailMultiSelectCampaign = new Campaign<CampaignEmbeddedMessageConfig>({
        remoteCampaignId: CampaignId.MiniMailMultiSelect,
        campaignSource: CampaignLightningRemoteSource.getInstance(CampaignId.MiniMailMultiSelect, {
            dismiss: 'Primary',
        }),
        rule: async () => await onLightningPresent(CampaignId.MiniMailMultiSelect),
        campaignType: new CampaignEmbeddedMessage(),
    });

    /** Mail Edge upsell campaign */
    mailEdgeUpsellCampaign = new Campaign<CampaignEmbeddedMessageConfig>({
        remoteCampaignId: CampaignId.MiniMailEdgeUpsell,
        campaignType: new CampaignEmbeddedMessage(),
        campaignSource: CampaignLightningRemoteSource.getInstance(CampaignId.MiniMailEdgeUpsell, {
            dismiss: 'Secondary',
            unmount: 'Secondary',
            click: 'Primary',
        }),
        rule: async () => await onLightningPresent(CampaignId.MiniMailEdgeUpsell),
    });

    isMailCampaignObjectsInitialized = true;

    /**
     * Soft deleting these campaigns, hence setting the value to null.
     * This code will be completely deleted at a later point.
     */
    mailWarmWelcomeCampaign = null;
    mailWarmWelcomeJourney = null;
}

export function getMailCampaignObjects() {
    if (!isMailCampaignObjectsInitialized) {
        initializeMailCampaignObjects();
    }
    return {
        mailCalendarNudgeCampaign,
        mailCalendarNudgeJourney,
        mailWarmWelcomeCampaign,
        mailWarmWelcomeJourney,
        mailFocusedOthersCampaign,
        mailMultiSelectCampaign,
        mailEdgeUpsellCampaign,
    };
}
